import { cva } from "class-variance-authority";

export const alertVariants = cva(
  "relative w-full rounded-md p-4 transition-colors [&>svg+div]:translate-y-[-4px] [&>svg]:absolute [&>svg]:left-3.5 [&>svg]:top-[18px] [&>svg~*]:pl-6",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground [&>svg]:text-foreground",
        primary:
          "border border-primary-soft-border bg-primary-soft text-primary-soft-foreground [&>svg]:text-primary",
        secondary:
          "border border-border bg-secondary text-secondary-foreground [&>svg]:text-secondary-foreground",
        error: "border border-error/20 bg-error/10 text-error [&>svg]:text-error",
        warning: "border border-warning/20 bg-warning-soft text-warning-strong [&>svg]:text-warning-strong",
        info: "border border-info/20 bg-info-soft text-info-strong [&>svg]:text-info-strong",
        success: "border border-success/20 bg-success-soft text-success-strong [&>svg]:text-success-strong",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
